import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { useGetFilter } from 'hooks/useSearchParamsObj';
import { useGetRootPath } from 'hooks/useShowLayout';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const RangePickerFilter = () => {
  const { filter } = useGetFilter();
  const { rootPath, search } = useGetRootPath();
  const navigate = useNavigate();

  const onChange = (dates) => {
    const searchParams = new URLSearchParams(search);
    searchParams.delete('page');
    searchParams.delete('pageSize');
    if (dates === null) {
      searchParams.delete('filters');
      navigate(`${rootPath}?${searchParams.toString()}`);
      return;
    }
    searchParams.set(
      'filters',
      JSON.stringify(
        [
          ...(filter?.filters?.filter(
            (item) => !['createdAt'].includes(item?.key),
          ) || []),
          {
            condition: 'and',
            key: 'createdAt',
            operator: 'gte',
            value: dates?.[0]?.toISOString(),
          },
          {
            condition: 'and',
            key: 'createdAt',
            operator: 'lte',
            value: dayjs(dates?.[1])?.endOf('day')?.toISOString(),
          },
        ],
        null,
        0,
      ),
    );
    navigate(`${rootPath}?${searchParams.toString()}`);
  };

  return (
    <div className="w-full flex justify-end items-center">
      <DatePicker.RangePicker
        format="YYYY-MM-DD"
        style={{ width: 300, height: 40 }}
        onChange={onChange}
        value={[
          dayjs(
            filter.filters?.find((item) => item?.operator === 'gte')?.value
              ? dayjs(
                  filter?.filters?.find((item) => item?.operator === 'gte')
                    ?.value,
                )
              : dayjs().subtract(1, 'month').startOf('month'),
            'YYYY/MM/DD',
          ),
          dayjs(
            filter.filters?.find((item) => item?.operator === 'lte')?.value
              ? dayjs(
                  filter?.filters?.find((item) => item?.operator === 'lte')
                    ?.value,
                )
              : dayjs(),
            'YYYY/MM/DD',
          ),
        ]}
      />
    </div>
  );
};

export default RangePickerFilter;
